<h3 [class.mb-2]="specification.description">{{specification.name}}</h3>
@if (specification.description) {
<p class="no-indent">
    <span> {{specification.description}} </span>
</p>
}

<h5>Routing</h5>
<p class="no-indent">
    <span>
        <span class="badge bg-cerrix">{{specification.httpMethod}}</span>
        <span class="d-inline ms-3">{{specification.path}}</span>
    </span>
</p>

@if (specification.parameters) {
<h5>Parameters</h5>
@for (param of specification.parameters; track param) {
<p>
    <strong> {{param.name}} </strong>
    @if (param.required) {
    <sup><small class="red">* required</small></sup>
    }
    <span> {{param.paramType}} <small>({{param.in}})</small> </span>
    @if (param.description) {
    <span style="white-space: pre-line">{{param.description}}</span>
    } @if (param.enum) {
    <span>
        Available values: @for (enum of param.enum; track enum) {
        <span class="badge bg-dark ms-2">{{enum}}</span>
        }
    </span>
    } @if (param.example) {
    <span>
        <pre class="example-block">{{param.example | json}}</pre>
    </span>
    }
</p>
} } @if (specification.responses) {
<h5>Responses</h5>
@for (response of specification.responses; track response) {
<p>
    <strong>{{response.code}}</strong>
    <i class="ms-2">{{response.description}}</i>
    @if (response.example) {
    <span class="mt-2">
        <pre class="example-block">{{response.example | json}}</pre>
    </span>
    }
</p>
} @if (!baseResponsesLoaded) {
<span class="inline-link" (click)="loadBaseResponses()"> Show default responses </span>
} }
